// extracted by mini-css-extract-plugin
module.exports = {"container":"F7b9Pybq5j0CA2BXwqiVp"};